import { cx } from 'emotion';
import memoize from 'memoize-one';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Pagination from '../Pagination';
import Select from '../Select';
import TextField from '../TextField';
export default class TablePagination extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            goToPage: '',
        };
        this.onPageChange = ({ selected }) => {
            this.props.onPageChange(selected);
        };
        this.onPageSizeChange = e => {
            e && this.props.onPageSizeChange(e.value);
        };
        this.onGoToPageChange = e => {
            this.setState({ goToPage: e.target.value });
        };
        this.onGoToPageSubmit = e => {
            if (e.key === 'Enter') {
                const parsedPage = parseInt(this.state.goToPage, 10);
                if (!Number.isNaN(parsedPage)) {
                    this.props.onPageChange(parsedPage - 1);
                }
            }
        };
        this.getPageSizeOptions = memoize(pageSizeOptions => pageSizeOptions.map(pageSize => ({ label: pageSize, value: pageSize })));
        this.getSelectedPageSizeOption = () => ({ label: this.props.pageSize, value: this.props.pageSize });
    }
    render() {
        const { className, page, pages, pageSizeOptions, showPageJump, showPageSizeOptions, goToLabelText, perPageLabelText } = this.props;
        const { goToPage } = this.state;
        if (pages < 1) {
            return null;
        }
        const pageSizeSelect = showPageSizeOptions ? (React.createElement(Select, { clearable: false, label: perPageLabelText, options: this.getPageSizeOptions(pageSizeOptions), value: this.getSelectedPageSizeOption(), onChange: this.onPageSizeChange })) : null;
        const pageJumpField = showPageJump ? (React.createElement(TextField, { label: goToLabelText, value: goToPage, onChange: this.onGoToPageChange, onKeyDown: this.onGoToPageSubmit })) : null;
        return (React.createElement("div", { className: cx(className, 'rt-pagination') },
            pageSizeSelect,
            pages > 1 && pageJumpField,
            pages > 1 && React.createElement(Pagination, { initialPage: page, forcePage: page, pageCount: pages, onPageChange: this.onPageChange })));
    }
}
TablePagination.propTypes = {
    className: PropTypes.string,
    page: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    pageSizeOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
    showPageJump: PropTypes.bool,
    showPageSizeOptions: PropTypes.bool,
    onPageChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    perPageLabelText: PropTypes.string,
    goToLabelText: PropTypes.string,
};
TablePagination.defaultProps = {
    perPageLabelText: 'Per Page',
    goToLabelText: 'Go To',
};
